import { Body } from "@elaniintc/goes-design-system";
import { cn } from "@/utils/theme";

const getValueColorClass = (valueColor: string) => {
  if (valueColor === "loud") {
    return "text-body-loud";
  }
  if (valueColor === "quiet") {
    return "text-body-quiet";
  }

  return "text-body";
};

interface PaymentRowProps {
  label: string;
  value: string | number | null;
  valueColor?: "default" | "loud" | "quiet" | (string & {});
  valueSize?: "default" | "sm" | "lg" | "xs";
  valueVariant?: "default" | "bold";
  isTotal?: boolean;
  useMonoFont?: boolean;
}

export const PaymentRow = ({
  label,
  value,
  valueColor = "loud",
  valueSize = "default",
  valueVariant = "default",
  isTotal = false,
  useMonoFont = false,
}: PaymentRowProps) => {
  const renderContent = () => {
    if (isTotal) {
      return (
        <p
          className={cn(
            "text-right text-[18px] leading-[32px] font-semibold",
            valueColor,
          )}
        >
          {value || "-"}
        </p>
      );
    }
    if (useMonoFont) {
      return (
        <p
          className={cn(
            "text-right font-geist-mono",
            getValueColorClass(valueColor),
          )}
        >
          {value || "-"}
        </p>
      );
    }

    return (
      <Body
        color={valueColor as "default" | "loud" | "quiet"}
        size={valueSize}
        variant={valueVariant}
        className="text-right"
      >
        {value || "-"}
      </Body>
    );
  };

  return (
    <div className="flex justify-between py-3">
      <Body color="default">{label}</Body>
      {renderContent()}
    </div>
  );
};
